import React, { useState, useContext } from "react";
import { AuthContext } from "./AuthContext";

const LoginPopup = () => {
  const { setToken } = useContext(AuthContext);
  const [user, setUser] = useState("");
  const [pass, setPass] = useState("");
  const [error, setError] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    
    // Enforce HTTPS in production
    if (
      process.env.NODE_ENV === "production" &&
      window.location.protocol !== "https:"
    ) {
      setError("Secure connection required");
      return;
    }
    
    const basePath = process.env.REACT_APP_BASE_PATH || "/";
    const baseUrl = basePath === "/" ? "/api" : `${basePath}/api`;
    const url = `${baseUrl}/login`;
    fetch(url, {
      method: "POST",
      headers: {
        Authorization: "Basic " + btoa(`${user}:${pass}`),
      },
    })
      .then((res) => {
        if (!res.ok) {
          return res.json().then((body) => {
            throw new Error(body?.error || body?.detail || `HTTP ${res.status}`);
          }).catch(() => {
            throw new Error(`HTTP ${res.status}`);
          });
        }
        return res.json();
      })
      .then((data) => setToken(data.token))
      .catch((err) => setError(err.message || "Login failed"));
  };

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center">
      <div className="max-w-md w-full mx-auto">
        <div className="bg-white shadow-lg rounded-lg overflow-hidden">
          <div className="bg-blue-600 text-white text-center py-5 px-6">
            <h3 className="text-xl font-semibold">WtW Data Dashboard</h3>
            <p className="text-blue-100">Please sign in to continue</p>
          </div>
          <div className="p-6">
            {error && (
              <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded mb-4 relative" role="alert">
                {error}
                <button 
                  type="button" 
                  className="absolute top-0 right-0 px-4 py-3" 
                  onClick={() => setError("")}
                  aria-label="Close"
                >
                  <span className="text-red-700 hover:text-red-900">&times;</span>
                </button>
              </div>
            )}

            <form onSubmit={handleSubmit} className="space-y-4">
              <div>
                <label htmlFor="username" className="block text-sm font-medium text-gray-700 mb-1">
                  Username
                </label>
                <input
                  type="text"
                  className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                  id="username"
                  value={user}
                  onChange={(e) => setUser(e.target.value)}
                  required
                />
              </div>
              <div>
                <label htmlFor="password" className="block text-sm font-medium text-gray-700 mb-1">
                  Password
                </label>
                <input
                  type="password"
                  className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                  id="password"
                  value={pass}
                  onChange={(e) => setPass(e.target.value)}
                  required
                />
              </div>
              <button 
                type="submit" 
                className="w-full bg-blue-600 text-white py-2 px-4 rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition-colors"
              >
                Sign In
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginPopup;
